import React from 'react';
import { motion } from 'framer-motion';
import { FolderAddIcon } from '../ios/IOSIcons';
import { useAtomValue } from 'jotai';
import { chatSidebarCollapsedAtom, chatSidebarWidthAtom, layoutModeAtom } from '../../../../atoms/v3/uiAtoms';

interface ProjectActionButtonProps {
  onClick: () => void;
}

/**
 * iOS 风格的项目创建按钮
 * 位于任务添加按钮上方的小型 FAB
 */
export const ProjectActionButton: React.FC<ProjectActionButtonProps> = ({ onClick }) => {
  const chatSidebarCollapsed = useAtomValue(chatSidebarCollapsedAtom);
  const chatSidebarWidth = useAtomValue(chatSidebarWidthAtom);
  const layoutMode = useAtomValue(layoutModeAtom);

  return (
    <motion.button
      onClick={onClick}
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{
        scale: 1,
        opacity: 1,
        boxShadow: '0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1)'
      }}
      transition={{ type: 'spring', stiffness: 300, damping: 25 }}
      className={`fixed ${layoutMode === 'desktop' ? 'bottom-[6.5rem]' : 'bottom-[10.5rem]'} w-8 h-8 rounded-full bg-ios-blue dark:bg-ios-dark-blue text-white flex items-center justify-center z-40`}
      style={{
        right: layoutMode === 'desktop' && !chatSidebarCollapsed
          ? `calc(${chatSidebarWidth}rem + 1rem)`
          : '1rem'
      }}
      aria-label="创建项目"
    >
      <div className="w-4 h-4">
        <FolderAddIcon />
      </div>
    </motion.button>
  );
};
